import { useTranslation } from 'next-i18next';

import { Typography } from '@/shared/components/atoms/Typography';
import SubscribeButton from '@/shared/components/molecules/SubscribeButton';
import { useModal } from '@/shared/hooks/context/modalContext/useModal';

import CheckMarkWithoutBG from '~/images/shared/CheckMarkWithoutBG.svg';
const Celebration = () => {
  const { t } = useTranslation();
  const { closeModal } = useModal();
  return (
    <div className='flex max-w-[420px] flex-col items-center gap-32'>
      <div className='flex h-64 w-64 items-center justify-center rounded-full bg-secondary-90 text-green-300'>
        <CheckMarkWithoutBG width='30' height='30' />
      </div>
      <div className='text-center'>
        <Typography variant='h2' weight='bold' className='mb-16'>
          {`${t('tour-celebration-title')} 👏`}
        </Typography>
        <Typography variant='subtitle' className='text-surface-10'>
          {t('tour-celebration-subtitle')}
        </Typography>
      </div>
      <SubscribeButton onRedirectEnd={() => closeModal()} />
    </div>
  );
};

export default Celebration;
